export const hasPlaceholder = (
  template: string,
  placeholder: string
): boolean => new RegExp(`\\{${placeholder}\\}`).test(template);

export const interpolate = (
  template: string,
  vars: Record<string, string | number>
): string =>
  template.replace(/\{(\w+)\}/g, (match, key) =>
    key in vars ? String(vars[key]) : match
  );
